import { Box, Button, Flex, Image, SimpleGrid, Text } from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import React from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getCourses, setGlobalCourses } from "redux/slices/coursesSlice";
import {
  selectCurrentCourse,
  setCurrentCourse,
  setIndex,
} from "redux/slices/currentCourseSlice";
import { selectCurrentFormation } from "redux/slices/currentFormationSlice";
import { setCurrentTest } from "redux/slices/currentTestSlice";
import { getTests, setGlobalTests } from "redux/slices/testsSlice";
import { Course, Test } from "types";
import CoursesTable from "views/admin/dataTables/components/CoursesTable";
import useTableDataCheck from "views/admin/dataTables/variables/tableDataCheck";

export default function SingleFormation() {
  const { currFormation } = useAppSelector(selectCurrentFormation);
  const { courses } = useAppSelector(getCourses);
  const { tests } = useAppSelector(getTests);
  const dispatch = useAppDispatch();

  const { currCourse, index } = useAppSelector(selectCurrentCourse);
  const history = useHistory();
  const navigateToCourse = (e: React.MouseEvent, course: Course) => {
    dispatch(setIndex(0));
    dispatch(setCurrentCourse(course));
    e.preventDefault();
    history.push("/course/get");
  };
  const navigateToTest = (e: React.MouseEvent, test: Test) => {
    dispatch(setIndex(0));
    dispatch(setCurrentTest(test));
    e.preventDefault();
    history.push("/test/get");
  };
  React.useEffect(() => {
    const getData = async () => {
      try {
        const res = await axios.get(`${apiurl}/course`);
        dispatch(setGlobalCourses([...res.data]));
      } catch (error) {
        console.log(error);
      }
    };

    getData();
  }, []);
  React.useEffect(() => {
    const getData = async () => {
      try {
        const res = await axios.get(`${apiurl}/test`);
        dispatch(setGlobalTests([...res.data]));
      } catch (error) {
        console.log(error);
      }
    };

    getData();
  }, []);
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
        <Flex
          direction="column"
          bg={"brand.500"}
          bgSize="cover"
          py={{ base: "30px", md: "56px" }}
          px={{ base: "30px", md: "64px" }}
          borderRadius="30px"
        >
          <Text
            fontSize={{ base: "24px", md: "34px" }}
            color="white"
            mb="14px"
            maxW={{
              base: "100%",
              md: "64%",
              lg: "46%",
              xl: "70%",
              "2xl": "50%",
              "3xl": "42%",
            }}
            fontWeight="700"
            lineHeight={{ base: "32px", md: "42px" }}
          >
            {currFormation.title}
          </Text>
          <Text
            fontSize="md"
            color="white"
            maxW={{
              base: "100%",
              md: "64%",
              lg: "40%",
              xl: "56%",
              "2xl": "46%",
              "3xl": "34%",
            }}
            fontWeight="500"
            mb="40px"
            lineHeight="28px"
          >
            {currFormation.description}
          </Text>
          <Image borderRadius={"30px"} src={currFormation.image} />
          <Flex mt={5} align="center">
            <Button
              bg="white"
              color="black"
              _hover={{ bg: "whiteAlpha.900" }}
              _active={{ bg: "white" }}
              _focus={{ bg: "white" }}
              fontWeight="500"
              fontSize="14px"
              py="20px"
              px="27"
              me="38px"
              onClick={(e) =>
                navigateToTest(
                  e,
                  tests.filter((test) => test.formationId === currFormation.id)[
                    index
                  ]
                )
              }
            >
              Passer le Test
            </Button>
            <Button
              colorScheme={"white"}
              fontWeight="500"
              fontSize="14px"
              py="20px"
              px="27"
              me="38px"
              onClick={(e) =>
                navigateToCourse(
                  e,
                  courses.filter(
                    (course) => course.formationId === currFormation.id
                  )[index]
                )
              }
            >
              Apprendre le cours
            </Button>
          </Flex>
        </Flex>
        <CoursesTable
          loading={false}
          tableData={useTableDataCheck().filter(
            (course) => course.formation === currFormation.title
          )}
        />
      </SimpleGrid>
    </Box>
  );
}
